import React, { Component } from 'react';
import { ReactComponent as LeftChevron } from '../assets/ico-left-chevron-ep.svg';
import { ReactComponent as RightChevron } from '../assets/ico-right-chevron-ep.svg';


class QuestionTotal extends Component {


    render() {
        return (
            <div className="top-nav">
                    <div className="button-nav leftChev">
                    <LeftChevron
                            className="question-swipe left"
                            key="left"
                            alt="left"
                            onClick={this.props.previousQuestion}>
                    </LeftChevron>
                    </div>
                <div className={`${this.props.brand} total`} id="total">{`${this.props.currentQuestion + 1} of ${this.props.questionCount}`}</div>
                <div className="button-nav rightChev">
                    <RightChevron
                            className="question-swipe right"
                            key="right"
                            alt="right"
                            onClick={this.props.nextQuestion}>
                    </RightChevron>
                    </div>
            </div>
        );
    }
}

export default QuestionTotal;